import { render } from "./Page_Edit.vue?vue&type=template&id=c234a556&scoped=true"
import script from "./Page_Edit.vue?vue&type=script&lang=js"
export * from "./Page_Edit.vue?vue&type=script&lang=js"

import "./Page_Edit.vue?vue&type=style&index=0&id=c234a556&scoped=true&lang=css"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c234a556"]])

export default __exports__